import { ImageFragment, ProductMetaFieldsFragment } from '../fragments'
import type { GraphqlConnection } from '@/types/graphql'
import type { Image } from '@/types/shopify'
import type { BundleProductVariant } from '@/types/bundle'


export interface BundleProductEdge {
  id: string
  title: string
  tags: string[]
  images: GraphqlConnection<Image>
  featuredImage: Image
  flavorForwardImage?: {
    value: string
    reference: Image
  }
  zoomImage?: {
    value: string
    reference: Image
  }
  nutritionImage?: {
    value: string
    reference: Image
  }
  nutritionFlavorForwardImage?: {
    value: string
    reference: Image
  }
  nutrition: {
    value: string
  }
  ratingAverage: {
    value: string
  }
  ratingCount: {
    value: string
  }
  protein: {
    value: string
  }
  calories: {
    value: string
  }
  ingredients?: {
    value: string
  }
  bgColor?: {
    value: string
  }
  variants: GraphqlConnection<BundleProductVariant>
}

export interface GetBundleProductQuery {
  product: BundleProductEdge
}

export const GetBundleProduct = `query getProductById($id: ID!) {
  product(id: $id) {
    id
    handle
    title
    description
    descriptionHtml
    tags
    createdAt
    images(first: 10) {
      edges {
        node {
          ${ImageFragment(1404)}
        }
      }
    }
    featuredImage {
      ${ImageFragment(640)}
    }
    ${ProductMetaFieldsFragment}
    variants(first: 1) {
      edges {
        node {
          id
          sku
          price {
            amount
            currencyCode
          }
        }
      }
    }
  }
}`
